<ion-header class="chat-config-drawer" [ngClass]="{ active: isDrawerOpen }">
  <div class="constrained-content config-container flexed">
    <ng-container *ngIf="isDev()">
      <div class="config-item start">
        <ion-label class="input-label">Selected Agent</ion-label>
        <ion-select
          [(ngModel)]="selectedAgent"
          class="select-outline config-input"
          aria-label="Model"
          interface="popover"
          placeholder="None Selected"
        >
          <ion-select-option *ngFor="let agent of agents" [value]="agent.id">{{ agent.name }}</ion-select-option>
        </ion-select>
      </div>
      <div class="config-item">
        <ion-label class="input-label">Impersonate User</ion-label>
        <ion-button
          *ngIf="!impersonatedUser?.name"
          class="config-input impersonate-user-button"
          fill="outline"
          (click)="selectUser()"
        >
          <ion-icon name="person-outline" class="padded-icon"></ion-icon>
          Select a User
          <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="impersonatedUser?.name"
          class="config-input impersonate-user-button"
          color="light"
          (click)="selectUser()"
        >
          <ion-icon name="person" class="padded-icon"></ion-icon>
          {{ impersonatedUser.name }}
        </ion-button>
      </div>
      <div class="config-item">
        <ion-label class="input-label">Customer</ion-label>
        <ion-button
          *ngIf="!customer?.name"
          class="config-input impersonate-user-button"
          fill="outline"
          (click)="selectCustomer()"
        >
          <ion-icon name="person-outline" class="padded-icon"></ion-icon>
          Select a Customer
          <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="customer?.name"
          class="config-input impersonate-user-button"
          color="light"
          (click)="selectCustomer()"
        >
          <ion-icon name="person" class="padded-icon"></ion-icon>
          {{ customer.name }}
        </ion-button>
      </div>
    </ng-container>
    <ng-container *ngIf="!isDev()">
      <div class="config-item start">
        <ion-label class="input-label">Impersonate User</ion-label>
        <ion-button
          *ngIf="!impersonatedUser?.name"
          class="config-input impersonate-user-button"
          fill="outline"
          (click)="selectUser()"
        >
          <ion-icon name="person-outline" class="padded-icon"></ion-icon>
          Select a User
          <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="impersonatedUser?.name"
          class="config-input impersonate-user-button"
          color="light"
          (click)="selectUser()"
        >
          <ion-icon name="person" class="padded-icon"></ion-icon>
          {{ impersonatedUser.name }}
        </ion-button>
      </div>
      <div class="config-item">
        <ion-label class="input-label">Customer</ion-label>
        <ion-button
          *ngIf="!customer?.name"
          class="config-input impersonate-user-button"
          fill="outline"
          (click)="selectCustomer()"
        >
          <ion-icon name="person-outline" class="padded-icon"></ion-icon>
          Select a Customer
          <ion-icon name="chevron-down-outline" class="icon-padded-left"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="customer?.name"
          class="config-input impersonate-user-button"
          color="light"
          (click)="selectCustomer()"
        >
          <ion-icon name="person" class="padded-icon"></ion-icon>
          {{ customer.name }}
        </ion-button>
      </div>
    </ng-container>
  </div>
  <ion-button (click)="toggleDrawer()" class="icon-button chat-config-drawer-toggle" fill="clear" color="dark">
    Toggle config drawer
    <ion-icon [name]="isDrawerOpen ? 'chevron-up-outline' : 'chevron-down-outline'" slot="end"></ion-icon>
  </ion-button>
</ion-header>

<ion-content>
  <ion-list class="message-list transparent-bg" lines="none">
    <ng-container *ngIf="!displayedMessages.length">
      <div class="empty-message-list-content" lines="none">
        <p style="font-size: 7.2rem; opacity: 0.2; margin: 35px">
          <ion-icon name="custom-bot"></ion-icon>
        </p>
        <span class="empty-message-list-placeholder">
          Use the message composer below to start a conversation with your AI agent
        </span>
      </div>
    </ng-container>
    <ion-item *ngFor="let message of displayedMessages" class="message-container">
      <ng-container *ngIf="isBot(message.role)">
        <div class="message-list-photo">
          <ion-icon name="custom-bot" style="font-size: 2.2rem; margin-right: 5px"></ion-icon>
        </div>
        <ion-card class="outline-card message-content-container">
          <span>
            <span>
              <strong>AI Agent</strong>
            </span>
            <span class="message-timestamp" title="{{ message.timestamp }}">
              <span> • {{ message.timestamp }}</span>
            </span>
          </span>
          <p [innerHTML]="convertToMarkdown(message.content)"></p>
          <ng-container *ngIf="message.suggestedTicketDetails">
            <ion-card class="outline-card embedded-card-content">
              <p><strong>Suggested Ticket:</strong></p>
              <ion-item>
                <ion-label slot="start">
                  <p>Project</p>
                </ion-label>
                <ion-label slot="end">
                  {{ message.suggestedTicketDetails.projectName }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label slot="start">
                  <p>Ticket Type</p>
                </ion-label>
                <ion-label slot="end">
                  {{ message.suggestedTicketDetails.ticketTypeName }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label slot="start">
                  <p>Summary</p>
                </ion-label>
                <ion-label slot="end" class="ticket-summary">
                  {{ message.suggestedTicketDetails.summarySoFar }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label slot="start">
                  <p>Title</p>
                </ion-label>
                <ion-label slot="end">
                  {{ message.suggestedTicketDetails.title }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label slot="start">
                  <p>Priority</p>
                </ion-label>
                <ion-label slot="end">
                  <ion-icon
                    [name]="getIconForPriority(message.suggestedTicketDetails.priority)"
                    *ngIf="getIconForPriority(message.suggestedTicketDetails.priority)"
                    class="icon-left"
                  ></ion-icon>
                  {{ message.suggestedTicketDetails.priority }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label slot="start">
                  <p>Tags</p>
                </ion-label>
                <ion-label slot="end">
                  <ion-chip *ngFor="let tag of message.suggestedTicketDetails.tagNames">
                    {{ tag }}
                  </ion-chip>
                </ion-label>
              </ion-item>
            </ion-card>
          </ng-container>
          <ng-container *ngIf="message.citations && message.citations.length">
            <ion-card class="outline-card embedded-card-content">
              <p><strong>Citations:</strong></p>
              <ion-item *ngFor="let citation of message.citations">
                <ion-label>
                  <a [href]="citation.url">{{ citation.content }}</a>
                </ion-label>
              </ion-item>
            </ion-card>
          </ng-container>
          <ng-container *ngIf="message.reasoningSteps && message.reasoningSteps.length">
            <ion-card class="outline-card embedded-card-content">
              <p><strong>Reasoning:</strong></p>
              <ion-item *ngFor="let reasoningStep of message.reasoningSteps">
                <p>{{ reasoningStep }}</p>
              </ion-item>
            </ion-card>
          </ng-container>
          <ng-container
            *ngIf="isViewAgentThoughtsEnabled() && message.formattedThoughts && message.formattedThoughts.length"
          >
            <ion-accordion-group class="show-thoughts-accordion-group">
              <ion-accordion class="show-thoughts-accordion" value="show thinking">
                <ion-item slot="header" class="accordion-header">
                  <p><strong>Show Thinking</strong></p>
                  <ion-icon
                    style="height: 1rem"
                    name="warning-outline"
                    color="warning"
                    *ngIf="message.aiThoughtsShowLowConfidence"
                    ngxTippy="Warning: Some of the thoughts have low confidence scores"
                  ></ion-icon>
                </ion-item>
                <ion-card slot="content" class="outline-card embedded-card-content">
                  <ion-item *ngFor="let thought of message.formattedThoughts; let i = index">
                    <ion-label>
                      <h3>{{ i + 1 }}. {{ thought.subject }}</h3>
                      <p class="thought-result">{{ thought.result }}</p>
                      <ng-container *ngIf="getObjectEntries(thought.aspects).length">
                        <ion-button
                          expand="block"
                          fill="clear"
                          (click)="thought.showThoughtAspects = !thought.showThoughtAspects"
                          style="margin: 20px 0"
                        >
                          <ion-icon
                            [name]="thought.showThoughtAspects ? 'chevron-up-outline' : 'chevron-down-outline'"
                            class="padded-icon"
                          ></ion-icon>
                          Show More Details
                        </ion-button>
                        <ng-container *ngIf="thought.showThoughtAspects">
                          <ng-container *ngIf="thought.aspects.aspect_format === ASPECT_FORMATS.KB_SEARCH_RESULTS">
                            <ion-item *ngFor="let searchResult of thought.aspects.all_search_results">
                              <ion-label>
                                <a [href]="searchResult.url">{{ searchResult.title }}</a>
                              </ion-label>
                            </ion-item>
                          </ng-container>
                          <ion-grid>
                            <ng-container *ngIf="!thought.aspects.aspect_format">
                              <ion-row *ngFor="let aspect of getObjectEntries(thought.aspects)">
                                <ion-col>
                                  <p>{{ aspect.key }}</p>
                                </ion-col>
                                <ion-col>
                                  <p>{{ aspect.value }}</p>
                                </ion-col>
                              </ion-row>
                            </ng-container>
                          </ion-grid>
                        </ng-container>
                      </ng-container>
                    </ion-label>
                  </ion-item>
                </ion-card>
              </ion-accordion>
            </ion-accordion-group>
          </ng-container>
        </ion-card>
      </ng-container>
      <ng-container *ngIf="!isBot(message.role)">
        <div class="message-list-photo">
          <app-avatar
            size="36"
            [style.width]="'36px'"
            [style.height]="'36px'"
            [image]="impersonatedUser ? impersonatedUser?.photoURL || null : user.photo"
            [name]="impersonatedUser?.name || user.name"
          >
          </app-avatar>
        </div>
        <ion-card class="outline-card message-content-container">
          <span>
            <span>
              <strong>{{ impersonatedUser?.name || user.name }}</strong>
            </span>
            <span class="message-timestamp" title="{{ message.timestamp }}">
              <span> • {{ message.timestamp }}</span>
            </span>
          </span>
          <div class="message-content" [innerHTML]="convertToMarkdown(message.content)"></div>
        </ion-card>
      </ng-container>
    </ion-item>
    <ng-container *ngIf="isAgentThinking">
      <ion-item class="message-container">
        <div class="message-list-photo">
          <ion-icon name="custom-bot" style="font-size: 2.2rem; margin-right: 5px"></ion-icon>
        </div>
        <ion-card class="outline-card message-content-container">
          <span>
            <span>
              <strong>AI Agent</strong>
            </span>
            <span class="message-timestamp">
              <span> • now</span>
            </span>
          </span>
          <p class="agent-thinking-message">Thinking</p>
        </ion-card>
      </ion-item>
    </ng-container>
    <ng-container *ngIf="isLastMessageError">
      <p class="error-message">last message failed to return response</p>
    </ng-container>
    <ng-container *ngIf="isAgentNotResponding">
      <p class="not-responding-message">the agent decided not to respond</p>
    </ng-container>
    <div class="message-composer">
      <ion-card class="message-composer-inner outline-card">
        <ion-textarea
          style="margin-top: 15px"
          autoGrow
          placeholder="Compose your message"
          [(ngModel)]="newMessage"
          (keydown)="handleKeyDown($event)"
        ></ion-textarea>
        <ion-button
          class="btn-small"
          [disabled]="isAgentThinking"
          (click)="sendMessage()"
          [color]="!newMessage ? 'light' : 'primary'"
        >
          <ion-icon name="send" style="font-size: 0.8rem; margin-right: 5px"></ion-icon>
          Send
        </ion-button>
      </ion-card>
    </div>
  </ion-list>
</ion-content>
